var VoiceStorageType = /* @__PURE__ */ ((VoiceStorageType2) => {
  VoiceStorageType2["NONE"] = "none";
  VoiceStorageType2["LOCAL"] = "local";
  VoiceStorageType2["REMOTE"] = "remote";
  return VoiceStorageType2;
})(VoiceStorageType || {});

export { VoiceStorageType };
//# sourceMappingURL=voice-storage-type.enum.js.map
